
import React, {Component} from "react";
import {
	TouchableOpacity,
	StyleSheet,
	View,
} from "react-native";
import global from "global";
import Style from "ae-style";
import StyledIcon from "ae-base/Base/StyledIcon";
import StyledText from "ae-base/Base/StyledText";

var styles = StyleSheet.create({
	inputStyle: {
		flexDirection: "row",
		marginVertical: Style.layout.marginContentSmall / 2,
		marginLeft: Style.layout.marginSlim,
		marginRight: Style.layout.marginSmall,
		paddingVertical: Style.layout.paddingSmall / 2,
		alignItems: "center",
		alignSelf: "flex-start"

	},
	iconStyle: {
		borderColor: Style.look.text,
		marginRight: Style.layout.marginSmall
	}

});

export default class CameraPickerWeb extends Component {
	constructor(props){
		super(props);
		this.openCamera = openCamera.bind(this);
	}

	render(){
		var props = this.props;
		var title = props.title;
		if(!global.cordova || !global.Camera) return;
		return (
			<TouchableOpacity id={props.id} accessibilityComponentType="button" onPress={this.openCamera}>
				<View style={styles.inputStyle}>
					<StyledIcon style={styles.iconStyle}  large name="camera" />
					<StyledText  bold>
						{title}
					</StyledText>
				</View>
			</TouchableOpacity>
		);
	}
}

function setOptions(srcType) {
	var options = {
		// Some common settings are 20, 50, and 100
		quality: 50,
		destinationType: global.Camera.DestinationType.FILE_URI,
		// In this app, dynamically set the picture source, Camera or photo gallery
		sourceType: srcType,
		encodingType: global.Camera.EncodingType.JPEG,
		mediaType: global.Camera.MediaType.PICTURE,
		correctOrientation: true,  //Corrects Android orientation quirks
		saveToPhotoAlbum: false
	};
	return options;
}

function openCamera() {

	var onAdd = this.props.onAdd;
	var srcType = global.Camera.PictureSourceType.CAMERA;
	var options = setOptions(srcType);

	global.navigator.camera.getPicture(function cameraSuccess(imageUri) {
		if(onAdd) onAdd({
			isNative: false,
			isCordova: true,
			url: imageUri,
			name: imageUri.substr(imageUri.lastIndexOf("/") + 1),
			type: "image"
		});

	}, function cameraError(error) {
		console.debug("Unable to obtain picture: " + error, "app");

	}, options);
}
